import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {ProjectSubscriptionService} from '../../../shared/services/project-subscription/project-subscription.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {StatesService} from '../../../shared/services/state/states.service';

@Component({
  selector: 'app-eventdyn-subscription',
  templateUrl: './eventdyn-subscription.component.html',
  styleUrls: ['./eventdyn-subscription.component.css']
})
export class EventdynSubscriptionComponent {
  projectId: number;
  projectName: string;
  public showSpinner: boolean;

  constructor(private projectSubscriptionService: ProjectSubscriptionService,
              @Inject(MAT_DIALOG_DATA) data: any,
              private toastrService: ToastrService,
              private translateService: TranslateService,
              private statesService: StatesService) {
    this.projectId = data.project.id;
    this.projectName = data.project.name;
  }

  subscribeProjectToEventdyn(projectId) {
    this.showSpinner = true;
    this.projectSubscriptionService.postEventdynSubscription(projectId).subscribe(
      () => {
        this.statesService.reloadListProject.next();
        this.showSpinner = false;
        this.toastrService.success(this.translateService.instant('EVENT_DYN_CREATED'));
      }, () => this.showSpinner = false
    );

  }
}
